import Vue from 'vue';

const copy = function (text, success, err) {
    if (!text) {
        if (err) {
            err("数据为空")
        }
        return
    }

    var input
    input = document.getElementById("plugIn-input")

    if (!input) {
        // 创建一个input节点
        var input = document.createElement("input");
    }

    input.value = text;
    input.setAttribute('type', 'text');
    input.id = "plugIn-input"
    input.style.opacity = "0"
    input.style.position = "absolute"
    input.style.top = "0"
    input.style.left = "-1000px"

    // 获取body
    document.body.appendChild(input);

    input.focus();
    input.select();

    try {
        if (document.execCommand('copy', false, null)) {
            if (success) {
                success()
            }
        } else {
            if (err) {
                err()
            }
        }
    } catch (e) {
        if (err) {
            err(e)
        }
    }


};

export default copy;



// WEBPACK FOOTER //
// ./src/vue/components/plugIn/copy/index.js